// SIZE_CONFIG is shared by both SelectCombobox (single-select) and
// MultiSelectCombobox (multi-select). Keys mirror the MultiSelect constants
// that previously lived in MultiSelect.constants.ts.
//
// Mobile (<768px) uses 16px input font-size to prevent iOS Safari auto-zoom
// on focus. Desktop (md+) keeps the original text sizes. Chip sizing is
// unchanged because chips are non-interactive badges that don't trigger
// iOS zoom.
export const SIZE_CONFIG: Record<
  "small" | "medium" | "large",
  { chips: string; input: string; chip: string; icon: string }
> = {
  small: {
    chips: "min-h-8 md:min-h-7 text-base md:text-xs gap-0.5 px-1 py-0.5",
    input: "text-base md:text-xs",
    chip: "h-4.5 text-[0.6875rem] px-1",
    icon: "size-3.5",
  },
  medium: {
    chips: "min-h-8 text-base md:text-sm gap-1 px-2.5 py-1",
    input: "text-base md:text-sm",
    chip: "h-5.25 text-xs px-1.5",
    icon: "size-4",
  },
  large: {
    chips: "min-h-10 text-base md:text-sm gap-1 px-2.5 py-1.5",
    input: "text-base md:text-sm",
    chip: "h-6 text-xs px-2",
    icon: "size-5",
  },
};
